import type { PropsWithChildren } from 'react'

export type CardHoverBackgroundProps = PropsWithChildren<unknown>

const CardHoverBackground = ({ children }: CardHoverBackgroundProps) => {
  return <div className='_w-full _p-4 _rounded-bottom _bg-primary'>{children}</div>
}

export default CardHoverBackground
